/**
 * @file Topbar 顶栏
 * @description 后台顶部条：左侧插槽 + 右侧操作。
 *
 * @whenToUse Admin Layout 顶部。
 * @whenNotToUse 页面内容标题（用 PageHeader）；图纸全屏页工具栏（用 DrawingToolbar）。
 */

import type { ReactNode } from 'react'
import { cn } from '@/lib/cn.ts'

export type TopbarProps = {
  /** 左侧（当前页标题与简介） */
  left?: ReactNode
  /** 右侧操作 */
  right?: ReactNode
  className?: string
}

export function Topbar({ left, right, className }: TopbarProps) {
  return (
    <header
      className={cn(
        'flex min-h-14 shrink-0 items-center justify-between gap-3 border-b border-border bg-raised px-3 py-1',
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {left}
      </div>
      <div className="flex shrink-0 items-center gap-2">{right}</div>
    </header>
  )
}
